import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { MatchRow } from "@/components/MatchCard";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useTranslation } from "react-i18next";

export default function ContactMatches({ contact, open, onOpenChange }) {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery({
    queryKey: ["contact-matches", contact?.id],
    queryFn: async () => (await api.get(`/matching/contact/${contact.id}`)).data,
    enabled: open && !!contact,
  });
  const results = (data?.results || []).filter((m) => m.match.score >= 40);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="bg-white w-full sm:max-w-lg overflow-y-auto" data-testid="contact-matches-sheet">
        <SheetHeader>
          <SheetTitle className="font-serif text-xl">{t("matching.viewMatchesFor", "Matches for")} {contact?.name}</SheetTitle>
          <SheetDescription className="text-sm text-slate-500">{t("matching.propertyMatchesSub", "Ranked by fit using budget, type, location, yield, analysis & buyer quality.")}</SheetDescription>
        </SheetHeader>
        <div className="mt-5 space-y-2">
          {isFetching && !data ? (
            <div className="flex justify-center py-10"><div className="animate-spin h-6 w-6 border-2 border-[#0B2545] border-t-transparent rounded-full" /></div>
          ) : results.length === 0 ? (
            <p className="text-slate-400 text-sm py-4">{t("matching.noMatches", "No matching properties yet.")}</p>
          ) : (
            results.map((m) => (
              <MatchRow key={m.property.id} name={m.property.title}
                subtitle={`${m.property.city || ""}${m.property.city ? " · " : ""}${m.property.category || ""}`}
                match={m.match} testid={`contact-match-${m.property.id}`} />
            ))
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
